import N, { z as E } from "zod";
var R = /* @__PURE__ */ ((l) => (l.STATIONARY = "ADB", l.ONLINE = "web", l.DEMO = "DEMO", l))(R || {}), O = /* @__PURE__ */ ((l) => (l.STATIONARY = "ADB", l.ONLINE = "web", l.DEMO = "DEMO", l))(O || {});
const M = E.union([
  E.literal(
    "web"
    /* ONLINE */
  ),
  E.literal(
    "ADB"
    /* STATIONARY */
  ),
  E.literal(
    "DEMO"
    /* DEMO */
  )
]).optional().default(
  "web"
  /* ONLINE */
);
var a = /* @__PURE__ */ ((l) => (l.CREATED = "CREATED", l.IDEAL_PAYMENT_PENDING = "IDEAL_PAYMENT_PENDING", l.PROCESSING = "PROCESSING", l.IN_PROGRESS = "IN_PROGRESS", l.ON_HOLD = "ON_HOLD", l.PENDING_ESIGNATURE = "PENDING_ESIGNATURE", l.PENDING_VERIFICATION = "PENDING_VERIFICATION", l))(a || {}), D = /* @__PURE__ */ ((l) => (l.CREATED = "CREATED", l.IDEAL_PAYMENT_PENDING = "IDEAL_PAYMENT_PENDING", l.PROCESSING = "PROCESSING", l.IN_PROGRESS = "IN_PROGRESS", l.ON_HOLD = "ON_HOLD", l.PENDING_ESIGNATURE = "PENDING_ESIGNATURE", l.PENDING_VERIFICATION = "PENDING_VERIFICATION", l))(D || {});
const s = E.union([
  E.literal("bg"),
  // Bulgarian
  E.literal("cs"),
  // Czech
  E.literal("da"),
  // Danish
  E.literal("de"),
  // German
  E.literal("el"),
  // Greek
  E.literal("en"),
  // English
  E.literal("es"),
  // Spanish
  E.literal("et"),
  // Estonian
  E.literal("fi"),
  // Finnish
  E.literal("fr"),
  // French
  E.literal("hr"),
  // Croatian
  E.literal("hu"),
  // Hungarian
  E.literal("is"),
  // Icelandic
  E.literal("it"),
  // Italian
  E.literal("lt"),
  // Lithuanian
  E.literal("lv"),
  // Latvian
  E.literal("mt"),
  // Maltese
  E.literal("nl"),
  // Dutch
  E.literal("pl"),
  // Polish
  E.literal("pt"),
  // Portuguese
  E.literal("ro"),
  // Romanian
  E.literal("sk"),
  // Slovak
  E.literal("sl"),
  // Slovenian
  E.literal("sv")
  // Swedish
]), G = E.union([
  E.literal("bg-BG"),
  // Bulgaria
  E.literal("cs-CZ"),
  // Czech Republic
  E.literal("da-DK"),
  // Denmark
  E.literal("de-AT"),
  // Austria
  E.literal("de-CH"),
  // Switzerland (German in Switzerland)
  E.literal("de-DE"),
  // Germany
  E.literal("de-LI"),
  // Liechtenstein
  E.literal("de-LU"),
  // Luxembourg (German in Luxembourg)
  E.literal("el-CY"),
  // Cyprus (Greek in Cyprus)
  E.literal("el-GR"),
  // Greece
  E.literal("en-GB"),
  // United Kingdom
  E.literal("en-GR"),
  // Greece
  E.literal("en-IE"),
  // Ireland
  E.literal("en-IS"),
  // Iceland (English)
  E.literal("es-ES"),
  // Spain
  E.literal("et-EE"),
  // Estonia
  E.literal("fi-FI"),
  // Finland (Finnish in Finland)
  E.literal("fr-BE"),
  // Belgium (French in Belgium)
  E.literal("fr-CH"),
  // Switzerland (French in Switzerland)
  E.literal("fr-FR"),
  // France
  E.literal("fr-LU"),
  // Luxembourg (French in Luxembourg)
  E.literal("hr-HR"),
  // Croatia
  E.literal("hu-HU"),
  // Hungary
  E.literal("is-IS"),
  // Iceland
  E.literal("it-CH"),
  // Switzerland (Italian in Switzerland)
  E.literal("it-IT"),
  // Italy
  E.literal("lt-LT"),
  // Lithuania
  E.literal("lv-LV"),
  // Latvia
  E.literal("mt-MT"),
  // Malta
  E.literal("nb-NO"),
  // Norway
  E.literal("nl-BE"),
  // Belgium (Dutch in Belgium)
  E.literal("nl-NL"),
  // Netherlands
  E.literal("no-NO"),
  // Norway
  E.literal("pl-PL"),
  // Poland
  E.literal("pt-PT"),
  // Portugal
  E.literal("ro-RO"),
  // Romania
  E.literal("sk-SK"),
  // Slovakia
  E.literal("sl-SI"),
  // Slovenia
  E.literal("sv-FI"),
  // Finland (Swedish in Finland)
  E.literal("sv-SE")
  // Sweden
]), Y = E.union([
  E.literal("at"),
  // Austria
  E.literal("be"),
  // Belgium
  E.literal("bg"),
  // Bulgaria
  E.literal("ch"),
  // Switzerland
  E.literal("cy"),
  // Cyprus
  E.literal("cz"),
  // Czech Republic
  E.literal("de"),
  // Germany
  E.literal("dk"),
  // Denmark
  E.literal("ee"),
  // Estonia
  E.literal("es"),
  // Spain
  E.literal("fi"),
  // Finland
  E.literal("fm"),
  E.literal("fr"),
  // France
  E.literal("gb"),
  // UK
  E.literal("gr"),
  // Greece
  E.literal("hr"),
  // Croatia
  E.literal("hu"),
  // Hungary
  E.literal("ie"),
  // Ireland
  E.literal("is"),
  // Iceland
  E.literal("it"),
  // Italy
  E.literal("li"),
  // Liechtenstein
  E.literal("lt"),
  // Lithuania
  E.literal("lu"),
  // Luxembourg
  E.literal("lv"),
  // Latvia
  E.literal("mt"),
  // Malta
  E.literal("nl"),
  // Netherlands
  E.literal("no"),
  E.literal("pl"),
  // Poland
  E.literal("pt"),
  // Portugal
  E.literal("ro"),
  // Romania
  E.literal("sb"),
  E.literal("se"),
  // Sweden
  E.literal("si"),
  // Slovenia
  E.literal("sk")
  // Slovakia
]), I = {
  AT: "AT",
  BE: "BE",
  BG: "BG",
  CH: "CH",
  CY: "CY",
  CZ: "CZ",
  DE: "DE",
  DK: "DK",
  EE: "EE",
  ES: "ES",
  FI: "FI",
  FM: "FM",
  FR: "FR",
  GB: "GB",
  GR: "GR",
  HR: "HR",
  HU: "HU",
  IE: "IE",
  IS: "IS",
  IT: "IT",
  LI: "LI",
  LT: "LT",
  LU: "LU",
  LV: "LV",
  MT: "MT",
  NL: "NL",
  NO: "NO",
  PL: "PL",
  PT: "PT",
  RO: "RO",
  SB: "SB",
  SE: "SE",
  SI: "SI",
  SK: "SK"
}, t = [
  "at",
  "be",
  "bg",
  "ch",
  "cy",
  "cz",
  "de",
  "dk",
  "ee",
  "es",
  "fi",
  "fm",
  "fr",
  "gb",
  "gr",
  "hr",
  "hu",
  "ie",
  "is",
  "it",
  "li",
  "lt",
  "lu",
  "lv",
  "mt",
  "nl",
  "no",
  "pl",
  "pt",
  "ro",
  "sb",
  "se",
  "si",
  "sk"
], V = E.enum(t), _ = [
  I.AT,
  I.BE,
  I.CH,
  I.DE,
  I.ES,
  I.FR,
  I.GB,
  I.IS,
  I.IT,
  I.NL,
  I.NO,
  I.PT,
  I.SE
], H = [
  ..._,
  I.BG,
  I.CY,
  I.CZ,
  I.DK,
  I.EE,
  I.FI,
  I.FM,
  I.GR,
  I.HR,
  I.HU,
  I.IE,
  I.LI,
  I.LT,
  I.LU,
  I.LV,
  I.MT,
  I.PL,
  I.RO,
  I.SB,
  I.SI,
  I.SK
], U = { CANARY_ISLANDS: "CA" }, m = { CANARY_ISLANDS: "CA" }, F = {
  MADEIRA: "PT-70",
  AZORES: "PT-60"
}, B = {
  MADEIRA: "PT-70",
  AZORES: "PT-60"
}, W = ["ES-35", "ES-38"], f = {
  CASH: "CASHBUY",
  LEASING: "LEASING",
  FINANCE: "FINANCE"
}, h = {
  LOA: "loa",
  BANK_PAYMENT: "payByInvoice",
  CARD: "card",
  SUBSIDIES: "",
  IDEAL: "ideal",
  THIRD_PARTY_FINANCING: "THIRD_PARTY_FINANCING",
  THIRD_PARTY_LEASING: "THIRD_PARTY_LEASING"
}, g = {
  COMMERCIAL: "commercial",
  PRIVATE: "private"
}, p = {
  ACCESSORY: "ACCESSORY",
  ADDITIONAL_COST: "ADDITIONAL_COST",
  CONNECTED_SERVICE: "CONNECTED_SERVICE",
  DIGITAL_SERVICE: "DIGITAL_SERVICE",
  // Extended warranty product
  EXTENDED_WARRANTY: "EXTENDED_WARRANTY",
  MARKETPLACE: "MARKETPLACE",
  VEHICLE_TIRE_TAX: "VEHICLETIRETAX",
  VEHICLE: "VEHICLE",
  VOUCHER: "VOUCHER",
  // Manufacturer warranty from Smart
  WARRANTY: "WARRANTY",
  WINTER_TIRE_TAX: "WINTERTIRETAX"
}, e = {
  ACCESSORY: "ACCESSORY",
  ADDITIONAL_COST: "ADDITIONAL_COST",
  CONNECTED_SERVICE: "CONNECTED_SERVICE",
  DIGITAL_SERVICE: "DIGITAL_SERVICE",
  DOWNPAYMENT: "DOWNPAYMENT",
  // Extended warranty product
  EXTENDED_WARRANTY: "EXTENDED_WARRANTY",
  MARKETPLACE: "MARKETPLACE",
  VEHICLE_TIRE_TAX: "VEHICLETIRETAX",
  VEHICLE: "VEHICLE",
  VOUCHER: "VOUCHER",
  // ISP (Manufacturer warranty from Smart)
  WARRANTY: "WARRANTY",
  WINTER_TIRE_TAX: "WINTERTIRETAX"
}, K = E.union([
  E.literal(e.ACCESSORY),
  E.literal(e.ADDITIONAL_COST),
  E.literal(e.CONNECTED_SERVICE),
  E.literal(e.DIGITAL_SERVICE),
  E.literal(e.DOWNPAYMENT),
  E.literal(e.EXTENDED_WARRANTY),
  E.literal(e.MARKETPLACE),
  E.literal(e.VEHICLE_TIRE_TAX),
  E.literal(e.VEHICLE),
  E.literal(e.VOUCHER),
  E.literal(e.WARRANTY),
  E.literal(e.WINTER_TIRE_TAX)
]), v = E.union([
  E.literal("dev"),
  E.literal("sit"),
  E.literal("stage"),
  E.literal("prod")
]), n = E.union([E.literal("true"), E.literal("false")]).transform((l) => l === "true"), b = n, C = E.object({
  headerName: E.string(),
  headerValue: E.string()
}), X = E.union([C, E.string().refine((l) => l.includes(":"))]).transform((l, A) => {
  if (typeof l == "object")
    return l;
  {
    const [i, r] = l.split(":");
    return !i || !r ? (A.addIssue({
      code: E.ZodIssueCode.custom,
      message: "Input was incorrect"
    }), E.NEVER) : { headerName: i, headerValue: r };
  }
}).optional(), d = "smart.com";
var L = /* @__PURE__ */ ((l) => (l.small = "small", l))(L || {});
const k = {
  DELIVERY_DATE: "deliveryDate",
  DELIVERY_DATE_MARKETPLACE: "deliveryDateMarketplace",
  DELIVERY_TIME: "deliveryTime",
  OUT_OF_STOCK: "outOfStock",
  WLTP: "WLTP",
  UMWELTBONUS: "umweltbonus",
  PRICE: "price",
  LEASING: "leasing",
  VEHICLE_CARD: "vehicleCard",
  DELIVERY_DETAILS_SURVEY: "deliveryDetailsSurvey",
  WALLBOX_PRICE: "wallboxPrice",
  CLASSIFICATION_ENGINE_BATTERY_SIZE: "smartClassificationCatalog/1.0/ENGINE.batterysize",
  CLASSIFICATION_POWER_ACCELERATION: "smartClassificationCatalog/1.0/POWER.acceleration",
  CLASSIFICATION_CONSUMPTION_DC_CHARGING_TIME: "smartClassificationCatalog/1.0/CONSUMPTION.dcchargingtime"
}, y = 60 * 60 * 24 * 30;
var S = /* @__PURE__ */ ((l) => (l[l.OK = 200] = "OK", l[l.CREATED = 201] = "CREATED", l[l.ACCEPTED = 202] = "ACCEPTED", l[l.NO_CONTENT = 204] = "NO_CONTENT", l[l.MOVED_PERMANENTLY = 301] = "MOVED_PERMANENTLY", l[l.FOUND = 302] = "FOUND", l[l.SEE_OTHER = 303] = "SEE_OTHER", l[l.NOT_MODIFIED = 304] = "NOT_MODIFIED", l[l.BAD_REQUEST = 400] = "BAD_REQUEST", l[l.UNAUTHORIZED = 401] = "UNAUTHORIZED", l[l.FORBIDDEN = 403] = "FORBIDDEN", l[l.NOT_FOUND = 404] = "NOT_FOUND", l[l.METHOD_NOT_ALLOWED = 405] = "METHOD_NOT_ALLOWED", l[l.CONFLICT = 409] = "CONFLICT", l[l.INTERNAL = 500] = "INTERNAL", l[l.NOT_IMPLEMENTED = 501] = "NOT_IMPLEMENTED", l[l.BAD_GATEWAY = 502] = "BAD_GATEWAY", l[l.SERVICE_UNAVAILABLE = 503] = "SERVICE_UNAVAILABLE", l[l.GATEWAY_TIMEOUT = 504] = "GATEWAY_TIMEOUT", l[l.HTTP_VERSION_NOT_SUPPORTED = 505] = "HTTP_VERSION_NOT_SUPPORTED", l))(S || {});
const w = {
  ACCESS_TOKEN: "access-token",
  BASE_SITE_ID: "base-site-id",
  CART_ID: "cart-id",
  CLIENT_ID: "client_id",
  CLIENT_SECRET: "client_secret",
  CUSTOMER_ID: "customer-id",
  ECOMM_ACCESS_TOKEN: "ecomm-access-token",
  ID_TOKEN: "id-token",
  SALES_CHANNEL: "X-Channel",
  USER_ID: "user-id"
}, P = {
  AWAITING_INPUT: "awaiting_input",
  DECLINED: "declined",
  NONE: "",
  PROCESSING: "processing",
  UNVERIFIED: "unverified"
}, c = {
  ABANDONED: "abandoned",
  APPROVED: "approved",
  ERROR: "error",
  REVIEW: "review"
}, T = {
  ...P,
  ...c
}, Z = N.union([
  N.literal(T.AWAITING_INPUT),
  N.literal(T.DECLINED),
  N.literal(T.PROCESSING),
  N.literal(T.UNVERIFIED)
]).optional(), z = N.union([
  N.literal(T.ABANDONED),
  N.literal(T.APPROVED),
  N.literal(T.ERROR),
  N.literal(T.REVIEW)
]).optional(), u = E.union([
  E.literal("HX11"),
  // Smart #1
  E.literal("HC11")
  // Smart #3
]), j = {
  CONSUMPTION: "CONSUMPTION",
  DIMENSION: "DIMENSION",
  EFFICIENCY_DATA: "EFFICIENCYDATA",
  ENGINE: "ENGINE",
  EU_TIRE_LABEL: "EU_TIRELABEL",
  POWER: "POWER",
  WEIGHTS: "WEIGHTS",
  PRODUCTIONDATA: "PRODUCTIONDATA"
};
export {
  W as CANARY_ISLANDS_ISO_CODES,
  a as CART_STATUS,
  D as CartStatus,
  k as FOOTNOTE_CODES,
  L as FontSize,
  w as HTTP_HEADER,
  m as ISLAND_MARKET,
  U as ISLAND_MARKETS,
  I as MARKET,
  H as MARKETS,
  _ as MARKETS_FOR_POSTAL_CODE,
  t as MARKET_ID,
  V as MARKET_ID_ENUM,
  u as ModelCodeSchema,
  c as ONFIDO_FINAL_STATUS,
  P as ONFIDO_POLLING_STATUS,
  T as ONFIDO_STATUS,
  h as PAYMENT_MODE,
  f as PAYMENT_TYPE,
  g as PRICE_TYPE,
  j as PRODUCT_CLASSIFICATION_CODE,
  e as PRODUCT_TYPE,
  p as PRODUCT_TYPES,
  F as PT_ISLANDS_ISO_CODE,
  B as PT_ISLAND_ISO_CODES,
  O as SALES_CHANNEL,
  R as SalesChannel,
  S as StatusCode,
  y as THIRTY_DAYS_IN_SECONDS,
  v as envNameSchema,
  s as languageSchema,
  G as languageTagSchema,
  Y as marketIdSchema,
  z as mockedOnfidoFinalStatusSchema,
  Z as mockedOnfidoPollingStatusSchema,
  n as previewSchema,
  K as productTypeSchema,
  X as rotatingVerifySecretSchema,
  M as salesChannelSchema,
  d as smartRootDomain,
  b as stringToBooleanSchema
};
//# sourceMappingURL=index.mjs.map
